import {
  GET_COMPANIES,
  GET_COMPANY,
  ADD_COMPANY,
  DELETE_COMPANY,
  UPDATE_COMPANY,
} from "../../type/companies";
// **  Initial State
const initialState = {
  data: [],
  start: 0,
  end: 0,
  totalRecords: 0,
  totalPages: 1,
  params: {},
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANIES:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default customerReducer;
